import React from 'react';
import ReactDom from 'react-dom';
import styled from 'styled-components';

const StyledDiv = styled.div`
    opacity: 1;
    transition: opacity ${props=>props.duration}ms;
    flex: 1;
    overflow: hidden;
    padding: 30px;
    text-align: left;

    &.hide {
        opacity: 0;
    }

    @media (max-width: 767px) {
        display: none;
    }

`;

const StyledContainer = styled.div`
    text-align: left;
    flex: 1;
    padding: 30px;
`;

export default class Description extends React.Component {

    constructor( props ){

        super( props );

        this.state = {
            text : props.text,
            changing: false
        }

    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.text != this.state.text ){

            this.setState( { changing: true }, (  ) => {
                setTimeout( () =>{
                    this.setState({changing:false, text: nextProps.text });
                }, this.props.duration );
            });

        }
        
    }

    render () {

        return (
            <StyledContainer>
                <div dangerouslySetInnerHTML={ {__html: productDescription} }>
                </div>
                <StyledDiv duration={this.props.duration} className={ this.state.changing ? 'hide' : 'show' } >
                    <div dangerouslySetInnerHTML={ {__html: this.state.text} }>
                    </div>
                </StyledDiv>
            </StyledContainer>
        )

    }

}